import stripePayment from "../../jquery/lsag.stripe";

class PlaceOrderController {
    /*@ngInject*/
    constructor(KlarnaPaymentService, CommonService) {
        this.paymentMode;
        this.requestPending = false;
        this.klarnaPaymentService = KlarnaPaymentService;
        this.commonService = CommonService;
        this.redirectErrorUrl = this.commonService.getBaseUrl() + '/cart?error=true';
    }

    init(klarnaPaymentClientToken, selectedPaymentMode) {
        this.paymentMode = selectedPaymentMode;
        this.klarnaPaymentClientToken = klarnaPaymentClientToken;
        if (this.klarnaTokenIsValid()) {
            this.klarnaPaymentService.initWidget(this.klarnaPaymentClientToken);
            this.klarnaPaymentService.loadWidget();
        }
    }

    submit(form) {
        this.requestPending = true;
        if (this.paymentMode.startsWith('klarnaPayment')) {
            if (this.klarnaTokenIsValid()) {
                this.klarnaPaymentService.authorize(this.klarnaAuthorizeCallback, form, this.redirectErrorUrl);
            } else {
                window.location.replace(this.redirectErrorUrl);
            }
        }
        else {
            form.$$element.submit();
        }
    }

    klarnaAuthorizeCallback(res, form, cartErrorUrl) {
        if (res.approved && res.show_form) {
            document.getElementById("authorizationToken").value = res.authorization_token;
            form.$$element.submit();
        } else {
            window.location.replace(cartErrorUrl);
        }
    }

    klarnaTokenIsValid() {
        return this.klarnaPaymentClientToken !== null && this.klarnaPaymentClientToken !== '';
    }

}

export default PlaceOrderController;